export default class AdminPresentingQuestions {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.adminPresentingQuestionsEndpoint, {
      params
    })
  }

  fetchQuestions(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminPresentingQuestionsEndpoint}/fetch-questions`, {
      params
    })
  }

  fetch(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminPresentingQuestionsEndpoint}/${id}`, {})
  }

  export(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminPresentingQuestionsEndpoint}/export/all`, {
      params,
      responseType: "blob"
    })
  }

  create(payload = {}) {
    return this.axiosIns.post(`${this.jwtConfig.main.adminPresentingQuestionsEndpoint}`, payload)
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminPresentingQuestionsEndpoint}/${id}`, payload, {})
  }

  delete(id, presenting_complaint_id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.adminPresentingQuestionsEndpoint}/${id}/presenting-complaint/${presenting_complaint_id}`, {})
  }
}
